import TContractEditPhoneNumber from './index.vue';

TContractEditPhoneNumber.install = app => {
  app.component(TContractEditPhoneNumber.name, TContractEditPhoneNumber);
};

export default TContractEditPhoneNumber;
